var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandFullScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / System / expand"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57143 8.14286C5.57143 8.85 4.99286 9.42857 4.28571 9.42857C3.57857 9.42857 3 8.85 3 8.14286V4.28571C3 3.57857 3.57857 3 4.28571 3H8.14286C8.85 3 9.42857 3.57857 9.42857 4.28571C9.42857 4.99286 8.85 5.57143 8.14286 5.57143H5.57143V8.14286ZM3 15.8572C3 15.15 3.57857 14.5715 4.28571 14.5715C4.99286 14.5715 5.57143 15.15 5.57143 15.8572V18.4286H8.14286C8.85 18.4286 9.42857 19.0072 9.42857 19.7143C9.42857 20.4215 8.85 21 8.14286 21H4.28571C3.57857 21 3 20.4215 3 19.7143V15.8572ZM18.4286 18.4286H15.8572C15.15 18.4286 14.5715 19.0072 14.5715 19.7143C14.5715 20.4215 15.15 21 15.8572 21H19.7143C20.4215 21 21 20.4215 21 19.7143V15.8572C21 15.15 20.4215 14.5715 19.7143 14.5715C19.0072 14.5715 18.4286 15.15 18.4286 15.8572V18.4286ZM15.8572 5.57143C15.15 5.57143 14.5715 4.99286 14.5715 4.28571C14.5715 3.57857 15.15 3 15.8572 3H19.7143C20.4215 3 21 3.57857 21 4.28571V8.14286C21 8.85 20.4215 9.42857 19.7143 9.42857C19.0072 9.42857 18.4286 8.85 18.4286 8.14286V5.57143H15.8572Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandFullScreen);
export default __webpack_public_path__ + "static/media/expandFullScreen.4da50123fa36a4e2c55a9a8b125bdae2.svg";
export { ForwardRef as ReactComponent };